import { types } from 'mobx-state-tree';

// const URL = 'catalog/v1';//use the actual endpoint when available

const CatalogItem = types
  .model('CatalogItem', {
    id: types.identifier(types.union(types.number, types.string)),
    selected: false,
    isPromotion: false,
    images: types.optional(types.array(types.string), []),
    categoryName: types.maybe(types.string),
    description: types.maybe(types.string),
    dimensions: types.optional(types.frozen, null), // {width: 10, height: 4, length: 12, measure: "Inch"}
    handlingTime: types.maybe(types.number),
    identifier: types.maybe(types.string),
    identifierType: types.maybe(types.string),
    location: types.maybe(types.string),
    mainImageUrl: types.maybe(types.string),
    price: types.maybe(types.number),
    quantity: types.maybe(types.number),
    retailPrice: types.maybe(types.number),
    shippingTime: types.maybe(types.number),
    returns: types.maybe(types.string),
    shipTo: types.maybe(types.string),
    status: types.maybe(types.string),
    supplier: types.maybe(types.string),
    supplierItemId: types.maybe(types.string),
    title: types.maybe(types.string),
    weight: types.optional(types.frozen, null), // {amount: 5, measure: "Lb"},
    condition: types.maybe(types.string),
    listingLimit: types.maybe(types.number),
  })
  .views(self => ({
    get weightString() {
      if (!self.weight) {
        return '';
      }
      const { amount, measure } = self.weight;
      return `${amount || 'N/A'} ${measure || ''}`;
    },
    get dimensionsString() {
      if (!self.dimensions) {
        return '';
      }
      const { width, height, length, measure } = self.dimensions;
      return `${width || 'W'} x ${height || 'H'} x ${length || 'L'} ${measure || ''}
    (width, height, length)`;
    },
    get htmlStrippedDescription() {
      return self.description.replace(/(<([^>]+)>)/gi, '');
    },
    get shortTitle() {
      return self.title.length < 40 ? self.title : `${self.title.slice(0, 40)}...`;
    },
    get parsedId() {
      if (typeof self.id === 'number') {
        return self.id;
      }
      return self.id.slice(0, 4) === '____' ? self.id.slice(4) : self.id;
    },
    get limited() {
      return self.listingLimit < 1;
    },
  }))
  .actions(self => ({
    setSelected(val) {
      self.selected = val;
    },
  }));

export default CatalogItem;
